//=================================================================
// push通知用スクリプト(スマフォ用)
//=================================================================

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';          // 共通変数
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as GFunc from '@/components/00/Common00';    // 共通メソッド

// Push通知
import { ActionPerformed, PushNotificationSchema, PushNotifications, Token } from '@capacitor/push-notifications';

/**
 * push通知の初期化処理
 */
export const initializePushNotification = async () =>
{
    if ( GFunc.isDebugEnabled() ) {console.log("initializePushNotification");}
   
    // push通知の許可を取得
    // Request permission to use push notifications
    // iOS will prompt user and return if they granted permission or not
    // Android will just grant without prompting
    PushNotifications.requestPermissions().then(async result => {
        if (result.receive === 'granted') {
            // Register with Apple / Google to receive push via APNS/FCM
            try {
                PushNotifications.register();
            }catch(e)
            {
                console.log("Error:"+`${e}`);
            }
        } else {
            // エラー
            console.log("Error:"+result.receive);
        }
    });

    // 端末登録時にトークンを受信時した時の処理
    // On success, we should be able to receive notifications
    PushNotifications.addListener('registration',
        (token: Token) => {
            console.log("registration");
            // alert('Push registration success, token: ' + token.value);
            if ( GFunc.isDebugEnabled() ) 
            { console.log('push通知用tokenを取得しました: ' + token.value); }
            // トークンを保存する
            GFunc.saveTrmnlTkn(token.value);
        }
    );

    // 端末登録時のエラー処理
    // Some issue with our setup and push will not work
    PushNotifications.addListener('registrationError',      
        (error: any) => {
            console.log('push通知用の端末登録に失敗しました: ' + JSON.stringify(error));
        }
    );

    // アプリ起動中にユーザーが通知を受信した時の処理
    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener('pushNotificationReceived',
        (notification: PushNotificationSchema) => {            
            if ( GFunc.isDebugEnabled() ) 
            { 
                console.log("アプリ起動中にpush通知発生: "+notification.data.link); 
                console.log('Push received: ' + JSON.stringify(notification));
            }
        }
    );

    // ユーザーが通知をタップした時の処理
    // Method called when tapping on a notification
    PushNotifications.addListener('pushNotificationActionPerformed',
        (notification: ActionPerformed) => {            
            // alert('Push action performed: ' + JSON.stringify(notification));
            if ( GFunc.isDebugEnabled() ) 
            { 
                console.log("push通知タップによる起動: "+notification.notification.data.link); 
                console.log('Push action performed: ' + JSON.stringify(notification));
            }
            // アプリ起動モード設定
            GVar.setRunMode("2");
            // ダイナミックリンクディスパッチャーを呼び出す
            GVar.dynamiclinkDispatcherFunc(Tools.getParamsDeeplink(notification.notification.data.link));            
        }
    );
}